import { Modal, Table } from "react-bootstrap";
import { getContext } from "../../../Helpers/Context/Context";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { MemberRegistrationUserType } from "../../../Helpers/Enums/MemberRegistrationUserType";

const UserDetailsModal = (props) => {
  const { showUserDetailsModal, setShowUserDetailsModal } = props;

  const context = getContext();

  const handleClose = () => {
    setShowUserDetailsModal(false);
  };

  const userDetails = [
    { label: "Name", value: `${context?.FirstName} ${context?.MiddleName} ${context?.LastName}` },
    { label: "Member ID", value: `${context?.MemberId}` },
    { label: "Member No", value: `${context?.MemberNo}` },
    { label: "Id", value: `${context?.Id}` },
    { label: "User Guid", value: `${context?.UserGuid}` },
    { label: "Employee No", value: `${context?.EmployeeNo}` },
    { label: "Email Id", value: `${context?.EmailId}` },
    { label: "Contact No", value: `${context?.ContactNo}` },
    { label: "Login Id", value: `${context?.LoginId}` },
    { label: "Roles", value: `${context?.Roles?.map((r) => r.RoleName)?.join(", ")}` },
    { label: "CurrentRoleId", value: `${RoleEnum[context?.CurrentRoleId]}` },
    { label: "UserType", value: `${MemberRegistrationUserType[context?.UserType as MemberRegistrationUserType]}` },
    //{ label: "Unit Codes ids for current role :", value: `${context?.Roles?.find((r) => r.RoleId === context?.CurrentRoleId)?.UnitCodes}` },
    { label: "Unit Codes for current role :", value: `${context?.Roles?.find((r) => r.RoleId === context?.CurrentRoleId)?.unitcodenames || "-----"}` },
  ];

  return (
    <>
      <Modal show={showUserDetailsModal} onHide={handleClose}>
        <Modal.Header closeButton style={{ backgroundColor: "#db233a" }} closeVariant="white" className="d-flex align-items-center">
          <Modal.Title>User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table borderless hover size="sm" className="d-flex justify-content-center">
            <tbody>
              {userDetails.map((bd) => {
                return (
                  <tr>
                    <td className="text-right">
                      <span style={{ fontSize: "14px" }}>{bd.label}</span>
                    </td>
                    <td>:</td>
                    <td className="text-left">
                      <span style={{ fontSize: "14px" }}>{bd.value}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserDetailsModal;
